import getGraphQlClient from '~graphql/getGraphQlClient';
import { FETCH_AI_CREDITS } from '../queries/ai_credits';
import { unmarshalGraphqlResponse } from '~graphql/utils';

export const fetchAiCredits = async () => {
  const graphQlClient = await getGraphQlClient();

  const result = await graphQlClient.query({
    query: FETCH_AI_CREDITS,
    fetchPolicy: 'network-only',
  });

  const credits = await unmarshalGraphqlResponse(
    result.data,
    'findRemovebgCredits'
  );

  return credits;
};
